import React, { useState, useContext } from 'react';
import API from '../api/api';
import {AuthContext} from '../context/AuthContext'; // Assuming you have this
import { useNavigate } from "react-router-dom";
import brand_logo from "../img/brand_logo.png"
import { toast } from 'react-toastify';

const Login = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '',  keep_connection: ''});
    const [error, setError] = useState(null);
    const { handleLogin } = useContext(AuthContext); // Use your AuthContext
    const navigate = useNavigate();

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const result = await handleLogin(credentials.username, credentials.password);
            if (!result.success) {
                //TODO('Invalid username or password');
                setError('Invalid username or password');
                toast.error("Username o password non valide.")
            }
            else{
               navigate("/home");
            }
        } catch (err) {
            //TODO('Invalid username or password');
            setError('Something went wrong. Please try again.');
        }
    };

    return (


        <div className="container">
          <div className="left-column">
            <div className="content">
              <img src={brand_logo} alt="Brand Logo" className="login-logo" />
              <h1>
               {process.env.REACT_APP_WELCOME_TITLE}
              </h1>
              <p>
               {process.env.REACT_APP_WELCOME_TEXT}
              </p>
            </div>
          </div>
          <div className="right-column">
            <form className="login-form" onSubmit={handleSubmit}>
                <label for="username">Mail</label>
                <input
                    type="text"
                    name="username"
                    placeholder="mail@sportlike.com"
                    value={credentials.username}
                    onChange={handleChange}
                    required
                />
                <label for="username">Password</label>
                <input
                    type="password"
                    name="password"
                    placeholder="**************"
                    value={credentials.password}
                    onChange={handleChange}
                    required
                />
                <input
                    type="checkbox"
                    name="keep_connection"
                />
                <span style={{marginLeft:"10px", color:"black"}}>
                Rimani connesso
                </span>
                <button type="submit" style={{marginTop:"20px"}}>Accedi</button>
            </form>
          </div>
        </div>



    );
};

export default Login;
